export default "__VITE_ASSET__15fyRCsu__"